import { createAction, props } from "@ngrx/store";
import { Agent } from "../../models/agent-fields";

const loadAgent = createAction(
  "[Agent] Load Agent",
  props<{ projectId: string }>()
);

const loadAgentSuccess = createAction(
  "[Agent] Load Agent Success",
  props<{ agentList: Agent[] }>()
);

const loadAgentFailure = createAction(
  "[Agent] Load Agent Failure",
  props<{ error: any }>()
);

const createAgent = createAction(
  "[Agent] Create Agent",
  props<{ projectId:string, data:any }>()
);

const createAgentSuccess = createAction(
  "[Agent] Create Agent Success",
  props<{ agent: Agent }>()
);

const createAgentFailure = createAction(
  "[Agent] Create Agent Failure",
  props<{ error: any }>()
);

const updateAgent = createAction(
  "[Agent] Update Agent",
  props<{  projectId:string, agent: Agent }>()
);

const updateAgentSuccess = createAction(
  "[Agent] Update Agent Success",
  props<{ agent: any }>()
);

const updateAgentFailure = createAction(
  "[Agent] Update Agent Failure",
  props<{ error: any }>()
);

const reclaimAgent = createAction(
  "[Agent] Reclaim Agent",
  props<{  projectId:string, agentIdList: any }>()
);

const reclaimAgentSuccess = createAction(
  "[Agent] Reclaim Agent Success",
  props<{ agents: any }>()
);

const reclaimAgentFailure = createAction(
  "[Agent] Reclaim Agent Failure",
  props<{ error: any }>()
);

const deleteAgent = createAction(
  "[Agent] Delete Agent",
  props<{ projectId:string, agentIdList:any }>()
);

const deleteAgentSuccess = createAction(
  "[Agent] Delete Agent Success",
  props<{ agentIdList: any }>()
);

const deleteAgentFailure = createAction(
  "[Agent] Delete Agent Failure",
  props<{ error: any }>()
);

export const AgentActions = {
  loadAgent,
  loadAgentSuccess,
  loadAgentFailure,
  createAgent,
  createAgentSuccess,
  createAgentFailure,
  updateAgent,
  updateAgentSuccess,
  updateAgentFailure,
  deleteAgent,
  deleteAgentSuccess,
  deleteAgentFailure,
  reclaimAgent,
  reclaimAgentSuccess,
  reclaimAgentFailure
};
